<template>
  <div>
    <div v-if="isFilterApplied" class="d-flex justify-content-end mb-3">
      <a
        href="javascript:;"
        class="btn btn-secondary w-60 display-6"
        @click="handleClearFilters"
      >
        Clear Filters
      </a>
    </div>
  </div>
  <form @submit.prevent="handleFilters">
    <div class="row filter-row">
      <div class="col-sm-6 col-md-3">
        <div
          class="input-block mb-3 form-focus"
          :class="{ focused: isFocused }"
        >
          <input
            type="text"
            :style="`${
              filters.search && 'border-bottom: var(--primary-color) 2px solid;'
            }`"
            class="form-control floating"
            v-model="filters.search"
            @focus="isFocused = true"
            @blur="isFocused = filters.search !== ''"
          />
          <label class="focus-label">Direct Manager</label>
        </div>
      </div>
      <div class="col-md-6"></div>
      <div class="d-flex col-sm-6 col-md-3 gap-2">
        <button
          type="submit"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="handleFilters"
        >
          Search
        </button>
        <button
          type="button"
          href="javascript:;"
          class="btn btn-success w-100"
          @click.prevent="resetAllFilters"
        >
          Reset
        </button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  data() {
    return {
      filters: {
        search: "",
      },
      isFocused: false,
      searched: false,
    };
  },
  props: {},
  methods: {
    handleFilters() {
      this.searched = true;
      this.$emit("apply-filters", this.filters);
    },

    resetAllFilters() {
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = "";
      });

      this.$emit("apply-filters", this.filters);

      this.searched = false;
    },

    handleClearFilters() {
      this.$emit("apply-filters", {});
      this.filters = {
        search: "",
      };
      this.searched = false;
    },
  },
  async created() {
    this.searched = false;
  },

  computed: {
    isFilterApplied() {
      const filtersHasProperty = Object.values(this.filters).filter(
        (el) => !!el,
      ).length;

      return this.searched && filtersHasProperty;
    },
  },
};
</script>
